/* ======================  SCRIPTS ====================== */
/************  JQUERY EST DISPONIBLE ICI *****************/

jQuery( document ).ready( function( $ ) {
    setup();
    
    function setup() {
        //initTarteAuCitron();
        initSocial();
        $('a, .is-anchor').click(goToAnchor);
        $('.btn-topage, #topPage').click(goTopPage);
    }
    
    function initTarteAuCitron() {
        tarteaucitron.init({
            "hashtag": "#tarteaucitron", /* Ouverture automatique du panel avec le hashtag */
            "highPrivacy": false, /* désactiver le consentement implicite (en naviguant) ? */
            "orientation": "bottom", /* le bandeau doit être en haut (top) ou en bas (bottom) ? */
            "adblocker": false, /* Afficher un message si un adblocker est détecté */
            "showAlertSmall": false, /* afficher le petit bandeau en bas à droite ? */
            "cookieslist": true, /* Afficher la liste des cookies installés ? */
            "removeCredit": true, /* supprimer le lien vers la source ? */
            "useExternalCss": true
        });
        
        (tarteaucitron.job = tarteaucitron.job || []).push('youtube');
    }
    
    function initSocial() {
        $('.social-share').click(copyLink);
        $('[data-social]').socialButtons();
    }
    
    // Fonction qui permet de copier l'url d'un article ou d'une offre d'emploi
    function copyLink() {
        $('body').append('<input type="url" class="urlToCopy sr-only" value="' + location.href + '"/>');
        var urlVal = $('.urlToCopy').select();
        document.execCommand('copy');
        $(this).children('.tooltip').addClass('copied');
        setTimeout(function() { $('.copied').removeClass('copied'); }, 1600);
    }
    
    // Animation pour aller aux ancres
    function goToAnchor(e) {
        var url = $(this).attr('href');
        var target = $(this).attr('target');
        if(url && url !== '#' && url.indexOf('#') !== -1 && target !=='_blank') {
            var id = url.split('#')[1];
            if(id.indexOf('/') === -1 && id !== '' && $('#'+id).length !== 0) {
                e.preventDefault();
                if($('.joboffers-offer.show').length !== 0 && $(window).width() < 1000) {
                    var scrollOffset = $('.joboffers-offer.show #' + id)[0].offsetTop - $('.joboffers-offer.show')[0].offsetTop;
                    $('.joboffers-offer.show').animate({ scrollTop: scrollOffset + 50 }, 500);
                }else {
                    var offset = $('#'+id).offset().top - 100;
                    $('html, body').animate({scrollTop: offset}, 1000);
                }
            }
        }
    }
    
    // Retour en haut de page
    function goTopPage() {
        $('html, body').animate({scrollTop: 0}, 1500);
    }
});

